import { useEffect, useState } from "react";

import AppCollection from "./parts/AppCollections";
import Categories from "./parts/Categories";
import Hero from "./parts/Hero";
import NewLatest from "./parts/NewLatest";
import GameRecommended from "./parts/Recommended";
import Top from "./parts/Top";

function Home() {
    const [pageLoaded, setPageLoaded] = useState(false);

    useEffect(() => {
        // If page already loaded (SPA navigation)
        if (document.readyState === "complete") {
            setPageLoaded(true);
        } else {
            window.addEventListener("load", () => {
                setPageLoaded(true);
            });
        }

        return () => {
            window.removeEventListener("load", () => { });
        };
    }, []);

    // ⛔ Hide everything until fully loaded
    if (!pageLoaded) {
        return null; // OR return a loader if you want
    }

    return (
        <main className="main-content">
            <Hero />
            <Categories />
            <GameRecommended />
            <AppCollection />
            <Top />
            <NewLatest />
        </main>
    );
}

export default Home;
